import { cn } from '@/lib/utils';
import { isEmpty } from '@/utils';
import { NavItems } from './navigation/configNav';
import { NavLink } from 'react-router-dom';
import { Separator } from '@radix-ui/react-separator';

type ConsoleLayoutNavbarProps = {
  title?: string;
  navbar?: NavItems;
  navbarFooter?: React.ReactNode;
};

const ConsoleLayoutNavbar = ({
  title,
  navbar = [],
  navbarFooter,
}: ConsoleLayoutNavbarProps) => {
  return (
    <>
      {!isEmpty(navbar) && (
        <div
          className="flex min-w-[220px] border-r"
          style={{ flex: '1 1 0px' }}
        >
          <div className="hide-scrollbar border-default flex h-full w-full flex-col">
            <div className="flex h-[var(--header-height)] items-center border-b bg-background-sidebar px-4">
              <p className="text-base font-medium">{title}</p>
            </div>
            <div className="flex-grow overflow-y-auto">
              <div className="flex h-full flex-col justify-between">
                <nav className="grid items-start px-2 pt-4 text-sm font-medium">
                  {navbar
                    .filter((item) => !item.isHidden)
                    .map((item, index) => (
                      <div key={index}>
                        <NavLink to={item.href} end={item.strictMatch}>
                          {({ isActive }) => (
                            <div
                              className={cn(
                                'flex items-center gap-2 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary',
                                isActive && 'bg-muted text-primary'
                              )}
                            >
                              {item.icon && item.icon}
                              {item.label}
                            </div>
                          )}
                        </NavLink>
                        {item.separator && <div className="my-2 h-px bg-border" />}
                      </div>
                    ))}
                </nav>

                <div className="pt-4 text-sm">{navbarFooter}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConsoleLayoutNavbar;
